import { useEffect } from "react";
import { useNavigate } from "@tanstack/react-router";
import { BarChart3, ClipboardList, LayoutDashboard, Send, Settings, ShieldCheck } from "lucide-react";
import { useAuthStore } from "@/stores/auth";
import { ShellScaffold, type ShellNavItem } from "@/components/ShellScaffold";
import { useTranslation } from "@/framework-originated/i18n";

// 供应商端外壳(doc/046 §5.1, doc/052 §2.1):能力子集
// (dashboard/distribute/tasks/usage/settings),视觉与运营端 ShellScaffold 同源。
// label 走 i18n(supplier:nav.*,doc/049 D5)。
function buildNav(t: (k: string) => string): ShellNavItem[] {
  return [
    { type: "leaf", item: { to: "/supplier/dashboard", label: t("nav.dashboard"), icon: LayoutDashboard } },
    { type: "leaf", item: { to: "/supplier/distribute", label: t("nav.distribute"), icon: Send } },
    { type: "leaf", item: { to: "/supplier/tasks/list", label: t("nav.tasks"), icon: ClipboardList } },
    { type: "leaf", item: { to: "/supplier/usage", label: t("nav.usage"), icon: BarChart3 } },
    { type: "leaf", item: { to: "/supplier/settings", label: t("nav.settings"), icon: Settings } },
  ];
}

export function SupplierAppShell({ children }: { children: React.ReactNode }) {
  const navigate = useNavigate();
  const { user, token, logout } = useAuthStore();
  const { t } = useTranslation("supplier");

  useEffect(() => {
    if (!token) navigate({ to: "/supplier/login" });
  }, [token, navigate]);

  if (!token) return null;

  return (
    <ShellScaffold
      brandMark={
        <div className="grid h-10 w-10 shrink-0 place-items-center rounded-[10px] bg-[#2363eb] text-white shadow-[0_7px_20px_#2363eb33]">
          <ShieldCheck size={22} />
        </div>
      }
      brandLabel="BizConsole"
      brandSub="供应商端 · 词元直连分发"
      sections={[{ label: "SUPPLIER", items: buildNav(t) }]}
      accountName={user?.username ?? "—"}
      accountSub={user?.role ?? "—"}
      onLogout={() => {
        logout();
        navigate({ to: "/supplier/login" });
      }}
      footer={t("common.masked")}
    >
      {children}
    </ShellScaffold>
  );
}